<template>
    <div class="container-fluid p-0">
        
        <homeLayout v-if="pageRouterPath == 'home'"></homeLayout>
        
        <div class="container p-3"  v-if="['zhengCeMap'].indexOf(pageRouterPath) !== -1">
            
            <!-- <b-breadcrumb  class="m-0 bg-white border-bottom" v-if="pageRouterPath !== 'home'">
                <b-breadcrumb-item v-for="(item,index) in items" :href="item.temp_file_name"  :active="index == items.length -1" class="align-middle">
                    {{item.text}}
                </b-breadcrumb-item>
            </b-breadcrumb> -->
            <layoutUnitMap></layoutUnitMap>
            <listLayout v-if="pageRouterPath == 'zhengCeMap'" :config = 'pageRouterQuery'></listLayout>
        </div>
        <div class="container p-3"  v-if="['policy','briefing','buTie','zhuanJing','gaoXin','zhengCeHot'].indexOf(pageRouterPath) !== -1">
            
            <!-- <b-breadcrumb  class="m-0 bg-white border-bottom" v-if="pageRouterPath !== 'home' && ['policy','briefing'].indexOf(pageRouterPath) !== -1" >
                <b-breadcrumb-item v-for="(item,index) in items" :href="item.temp_file_name"  :active="index == items.length -1" class="align-middle">
                    {{item.text}}
                </b-breadcrumb-item>
            </b-breadcrumb> -->
            <bannerLayout :type="'banner'" :config="banner"></bannerLayout>
            <listLayout v-if="pageRouterPath == 'policy'" :config = 'pageRouterQuery'></listLayout>
            <listLayout v-if="pageRouterPath == 'zhengCeHot'" :config = 'pageRouterQuery'></listLayout>
            <listLayout v-if="pageRouterPath == 'briefing'" :config = 'pageRouterQuery'></listLayout>
            <listLayout v-if="['buTie','zhuanJing','gaoXin'].indexOf(pageRouterPath) !== -1" :config = 'pageRouterQuery'></listLayout>
        </div>
        <div class="container p-3"  v-if="['policyDetail','briefingDetail'].indexOf(pageRouterPath) !== -1">
            <detail v-if="pageRouterPath == 'policyDetail'" :type="pageRouterPath" :config = 'pageRouterQuery'></detail>
            <detail v-if="pageRouterPath == 'briefingDetail'" :type="pageRouterPath" :config = 'pageRouterQuery'></detail>
        </div>
        <div class="container p-3"  v-if="['mediaDetails'].indexOf(pageRouterPath) !== -1">
            <detail v-if="pageRouterPath == 'mediaDetails'" :type="pageRouterPath" :config = 'pageRouterQuery'></detail>
        </div>
        <div class="container p-3"  v-if="['zhengCePiPei'].indexOf(pageRouterPath) !== -1">
            <bannerLayout :type="'banner'" :config="banner"></bannerLayout>
        </div>
        <div class="container p-3"  v-if="['youQingLink'].indexOf(pageRouterPath) !== -1"  style="min-height: 50vh;">
            
            <!-- <bannerLayout :type="'banner'" :config="banner"></bannerLayout> -->
            <layoutUnit :type="'cards'" title="友情链接" v-if="pageRouterQuery.content" :content="pageRouterQuery.content ? pageRouterQuery.content : []"></layoutUnit>
        </div>
        <footerLayout v-if="website" :navs="footerNavs"></footerLayout>
    </div>
  </template>
  
  <script>
  import mapTitleImg from '@/assets/mapTitle.png'
  import not from '@/assets/not.png'

  import homeLayout from '@/components/homeLayout.vue'
  import listLayout from '@/components/listLayout.vue'
  import detail from '@/components/detail.vue'
  import bannerLayout from '@/components/bannerLayout.vue'
  import footerLayout from '@/components/footerLayout.vue'
  import layoutUnitMap from '@/components/layoutUnitMap.vue'
  import layoutUnit from '@/components/layoutUnit.vue'
  import pipeibg from '@/assets/pipeibg.png'
  export default {
    name: 'mainUi',
    components: {
        homeLayout,footerLayout,listLayout,bannerLayout,detail,layoutUnitMap,layoutUnit
    },
    props: {
        pageRouterPath:{
            type:String,
            default(){
                return 'home'
            }
        },
        pageRouterQuery:{
            type:Object,
            default(){
                return null
            }
        },
        footer:{
            type:String,
            default(){
                return 'more' // pagination
            }
        },
        type:{
            type:String,
            default(){
                return 'text'  // text   map   list
            }
        },
        content:{
            type:[Object,Array],
            default(){
                return null
             
            }
        },
        title:{
            type:String,
            default(){
                return ''
            }
        },
        bannerText:{
            type:String,
            default(){
                return ''
            }
        },
        footerNavs:{
            type:[Object,Array],
            default(){
                return null
             
            }
        }
    },
    mounted(){ 
        if(this.$route.name == 'zhengCePiPei'){
            this.banner.backgroundImg = not
        }
    },
    computed:{
        
        items(){
            let items = [{
                text:"首页",
                href:"/", 
                temp_file_name:"/"

            }]
            let avtiveNavs = sessionStorage.getItem('avtiveNav') ? this.bxDeepClone( JSON.parse(sessionStorage.getItem('avtiveNav'))) : null
            if(avtiveNavs && avtiveNavs.temp_file_name !== '/'){
                avtiveNavs['text'] = avtiveNavs.name
                avtiveNavs['href'] = avtiveNavs.temp_file_name
                avtiveNavs['disabled'] = !avtiveNavs['href']
                items.push(this.bxDeepClone(avtiveNavs))
            }
            if(avtiveNavs && avtiveNavs.avtiveChildText && avtiveNavs.children){
                let child = avtiveNavs.children.filter(item => item.name == avtiveNavs.avtiveChildText)[0]
                child['text'] = child.name
                child['href'] = child.temp_file_name
                items.push(this.bxDeepClone(child))
            }
            return items
        },
        website(){
            let info = ''
            info = sessionStorage.getItem('basisInfo') ? this.bxDeepClone( JSON.parse(sessionStorage.getItem('basisInfo'))) : null

            return info
        }
    },
    data() {
      return {
        titleImg:mapTitleImg,
        provinceName:"",
        banner:{
            title:this.bannerText,
            subTitle:"",
            backgroundImg:pipeibg,
            serviceName:"",
            type:"banner",
            footer:"",
            row:1,
            templateType:"1",
            pageRowNumber:4
        }
      }
    },
      methods: {
    },
    watch:{
        "website":{
            deep:true,
            handler:function(nval,oval){
                console.log(nval,oval)
                if(nval){
                    this.$forceUpdate()
                }
            }
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  